export default "__VITE_ASSET__BtyxO23u__"